import React from 'react';
import {
  ButtonsContainer,
  TitleAndSubtitle,
  ContentButtonsWrapper,
} from '../../../layout/layout-container.styled';
import { NavButton } from '../../../nav-button/nav-button';
import { Text, font } from '../../../../style-utils/text';
import { CheckRing } from '../../../icons/check-ring';
import { OptionsInput } from '../../../styled-options/styled-options';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { DailyLogState } from '../../../hooks/use-daily-log-handler';
import { palette } from '../../../../style-utils/theme';
import { useOptionAdvance } from '../../../hooks/use-option-advance';

export const Priority: React.FC<DefaultComponentProps> = ({
  navigate,
  state,
  changeHandler,
  options,
  nextPath,
  prevPath,
}) => {
  const { priority } = state as DailyLogState;
  const { selectAndAdvance } = useOptionAdvance({
    onSelect: value => changeHandler(value, 'priority', value),
    onAdvance: () => navigate(nextPath, { replace: false }),
  });

  return (
    <>
      <TitleAndSubtitle direction="column">
        <Text as="h1" fontSize={font.size.xl} fontWeight={700} mt={0} mb={8}>
          Priority
        </Text>
        <Text color={font.color.gray} fontSize={font.size.xs} mt={0} mb={0}>
          Please select one of the options below
        </Text>
      </TitleAndSubtitle>
      <ContentButtonsWrapper>
        <OptionsInput
          options={options && options?.length >= 1 ? options : []}
          selectedOption={priority}
          icon={<CheckRing />}
          changeHandler={changeHandler}
          changeHandlerName="priority"
          onOptionSelected={selectAndAdvance}
        />
      </ContentButtonsWrapper>
      <ButtonsContainer>
        <NavButton
          disabled={false}
          onClick={() => navigate(prevPath, { replace: false })}
          direction="back"
          textColor={palette.slate}
          background="transparent"
          text={'Back'}
        />
      </ButtonsContainer>
    </>
  );
};
